module.exports = "https://static.wmbcdn.com/uniweb/images/a4f817ed2d1996dcbf36727430589265.svg";